module.exports = __webpack_public_path__ + "static/media/plantronics-backbeat-go-410.8460b3a9.jpg";